import { ArrowDown } from 'lucide-react';

export default function PaperCard({ paper }) {
    return (
      <div className="border rounded-lg shadow-md overflow-hidden flex flex-col md:flex-col m-3">
        <div className="relative w-full md:w-full">
          <img
            src={`${process.env.REACT_APP_POCKETBASE_URL}/api/files/${paper.collectionId}/${paper.id}/${paper.image}`} 
            alt={paper.title}
            className="w-full h-48 md:h-full object-cover"
          />
          <span className="absolute top-2 left-2 bg-gray-800 text-white text-xs px-2 py-1 rounded">
            {paper.varient}
          </span>
        </div>
        <div className="w-full md:w-full p-4">
          <h2 className="text-blue-600 text-lg font-semibold hover:underline cursor-pointer">
            {paper.title}
          </h2>
          <p className="text-gray-600 text-sm mt-2">
            {paper.description}
          </p>
          <a
          href={`${process.env.REACT_APP_POCKETBASE_URL}/api/files/${paper.collectionId}/${paper.id}/${paper.file}`}
          download
          target="_blank"
          rel="noopener noreferrer"
          className="w-full text-center no-underline px-2 py-1 lg:px-3 lg:py-2 bg-primary text-white rounded-md hover:bg-opacity-80 flex flex-row items-center justify-center gap-1 lg:gap-2 text-sm lg:text-base hover:bg-blue-600 transition duration-200 h-10"
        >
          <span className="whitespace-nowrap inline-flex items-center gap-1 lg:gap-2">
            Download <ArrowDown />
          </span>
        </a>
        </div>
      </div>
    );
  } 